import { FractionalType } from "./Constants";

/**
 * A converter which converts Fractional Price
 * types to Decimal and validates based on the tick size provided.
 *
 * @author  E42303 Judhjit Ganguli
 */
const decimal = require("decimal.js");

export function FractionalToDecimalConverter(
  FractionalPriceValue,
  fractionalType,
) {
  //convert to decimal notation

  const FractionalPrice = parseFloat(
    FractionalPriceValue?.toString().replace("'", "."),
  );

  //split into integer
  const integer_part =
    fractionalType == "NotFractional"
      ? parseInt(FractionalPrice.toLocaleString())
      : parseInt(FractionalPrice);

  var decimal_number = 0;

  switch (fractionalType) {
    case "NotFractional":
      decimal_number = FractionalPrice;
      break;
    case FractionalType.HALVES: // Only Options not Futures
      var fractional_part_Halves = ((FractionalPrice % 1) * 10).toFixed(
        count(FractionalPrice),
      );
      decimal_number = integer_part + fractional_part_Halves / 10;
      if (fractional_part_Halves == 5 || fractional_part_Halves == 0) {
        decimal_number = integer_part + fractional_part_Halves / 10;
      } else {
        return { decimal_number: decimal_number, valid: false };
      }
      break;
    case FractionalType.QUARTERS: //products not available
    // if (decimal_part == 2) {
    //     decimal_number = integer_part + 0.25;
    // } else if (decimal_part == 5) {
    //     decimal_number = integer_part + 0.5;
    // } else if (decimal_part == 7) {
    //     decimal_number = integer_part + 0.75;
    // } else {
    //     decimal_number = integer_part;
    // }
    // break;
    case FractionalType.EIGHTS:
      var fractional_part_Eighths = ((FractionalPrice % 1) * 10).toFixed(
        count(FractionalPrice),
      );
      // decimal_number = integer_part + fractional_part_Eighths / 8;
      if (
        fractional_part_Eighths > -8 &&
        fractional_part_Eighths < 8 &&
        fractional_part_Eighths % 1 == 0
      ) {
        decimal_number = integer_part + fractional_part_Eighths / 8;
      } else {
        return { decimal_number: integer_part, valid: false };
      }
      break;
    case FractionalType.SIXTEENTHS: //products not available
      // decimal_number = integer_part + (fractional_part / 16);
      break;
    case FractionalType.THIRTY_SECONDS:
      var fractional_part_ThirtySeconds = ((FractionalPrice % 1) * 100).toFixed(
        count(fractional_part_ThirtySeconds),
      );
      // decimal_number = integer_part + fractional_part_ThirtySeconds / 32;
      if (
        fractional_part_ThirtySeconds < 32 &&
        fractional_part_ThirtySeconds > -32
      ) {
        decimal_number = integer_part + fractional_part_ThirtySeconds / 32;
      } else {
        return { decimal_number: integer_part, valid: false };
      }
      break;
    case FractionalType.SIXTY_FOURTHS: // Only Options not Futures
      var fractional_part_SixtyFourths = ((FractionalPrice % 1) * 100).toFixed(
        count(FractionalPrice),
      );
      // decimal_number = integer_part + fractional_part_SixtyFourths / 64;
      if (
        fractional_part_SixtyFourths < 64 &&
        fractional_part_SixtyFourths > -64
      ) {
        decimal_number = integer_part + fractional_part_SixtyFourths / 64;
      } else {
        return { decimal_number: integer_part, valid: false };
      }
      break;
    case FractionalType.HALF_THIRTY_SECONDS:
      var fractional_part_HalfThirtySeconds = (
        (FractionalPrice % 1) *
        100
      ).toFixed(count(FractionalPrice));
      if (
        fractional_part_HalfThirtySeconds < 31.6 &&
        fractional_part_HalfThirtySeconds > -31.6
      ) {
        const mainFraction = parseInt(fractional_part_HalfThirtySeconds);
        const subFraction = (((FractionalPrice * 100) % 1) * 10).toFixed(0);
        const intermediateNumber = integer_part + mainFraction / 32;

        if (subFraction == 0) {
          decimal_number = intermediateNumber;
        } else if (subFraction == 5) {
          decimal_number = intermediateNumber + 0.5 / 32;
        } else if (subFraction == -5) {
          decimal_number = intermediateNumber - 0.5 / 32;
        } else {
          decimal_number = integer_part;
          return { decimal_number: decimal_number, valid: false };
        }
      } else {
        return { decimal_number: integer_part, valid: false };
      }
      break;
    case FractionalType.QUARTER_THIRTY_SECONDS:
      var fractional_part_QuarterThirtySeconds = (
        (FractionalPrice % 1) *
        100
      ).toFixed(count(FractionalPrice));
      if (
        fractional_part_QuarterThirtySeconds < 31.8 &&
        fractional_part_QuarterThirtySeconds > -31.8
      ) {
        const mainFraction = parseInt(fractional_part_QuarterThirtySeconds);
        const subFraction = (
          (fractional_part_QuarterThirtySeconds % 1) *
          10
        ).toFixed(0);
        const intermediateNumber = integer_part + mainFraction / 32;

        if (subFraction == 0) {
          decimal_number = intermediateNumber;
        } else if (subFraction == 2) {
          decimal_number = intermediateNumber + 0.25 / 32;
        } else if (subFraction == 5) {
          decimal_number = intermediateNumber + 0.5 / 32;
        } else if (subFraction == 7) {
          decimal_number = intermediateNumber + 0.75 / 32;
        } else if (subFraction == -2) {
          decimal_number = intermediateNumber - 0.25 / 32;
        } else if (subFraction == -5) {
          decimal_number = intermediateNumber - 0.5 / 32;
        } else if (subFraction == -7) {
          decimal_number = intermediateNumber - 0.75 / 32;
        } else {
          decimal_number = integer_part;
          return { decimal_number: decimal_number, valid: false };
        }
      } else {
        return { decimal_number: integer_part, valid: false };
      }
      break;
    case FractionalType.EIGHTH_THIRTY_SECONDS:
      var fractional_part_EighthThirtySeconds = (
        (FractionalPrice % 1) *
        100
      ).toFixed(count(FractionalPrice));
      if (
        fractional_part_EighthThirtySeconds < 31.9 &&
        fractional_part_EighthThirtySeconds > -31.9
      ) {
        const mainFraction = parseInt(fractional_part_EighthThirtySeconds);
        const subFraction = (((FractionalPrice * 100) % 1) * 10).toFixed(0);
        const intermediateNumber = integer_part + mainFraction / 32;

        if (subFraction >= 0 && subFraction <= 3) {
          decimal_number = intermediateNumber + subFraction * (0.125 / 32);
        } else if (subFraction >= 5 && subFraction <= 8) {
          decimal_number =
            intermediateNumber + 1 * (Math.abs(subFraction) - 1) * (0.125 / 32);
        } else if (subFraction == 10) {
          decimal_number = intermediateNumber + 0 * (0.125 / 32);
        } else if (subFraction < 0 && subFraction >= -3) {
          decimal_number = intermediateNumber + subFraction * (0.125 / 32);
        } else if (subFraction <= -5 && subFraction >= -8) {
          decimal_number =
            intermediateNumber +
            -1 * (Math.abs(subFraction) - 1) * (0.125 / 32);
        } else if (subFraction == -10) {
          decimal_number = intermediateNumber - 0 * (0.125 / 32);
        } else {
          //case for subfraction == 9, 4, -9, -4
          decimal_number = integer_part;
          return { decimal_number: decimal_number, valid: false };
        }
      } else {
        return { decimal_number: integer_part, valid: false };
      }
      break;
    case FractionalType.HALF_SIXTY_FOURTHS: // Only Options not Futures
      var fractional_part_HalfSixtyFourths = (
        (FractionalPrice % 1) *
        100
      ).toFixed(count(FractionalPrice));
      if (
        fractional_part_HalfSixtyFourths < 63.6 &&
        fractional_part_HalfSixtyFourths > -63.6
      ) {
        const mainFraction = parseInt(fractional_part_HalfSixtyFourths);
        const subFraction = (((FractionalPrice * 100) % 1) * 10).toFixed(0);
        const intermediateNumber = integer_part + mainFraction / 64;

        if (subFraction == 5) {
          decimal_number = intermediateNumber + 0.5 / 64;
        } else if (subFraction == -5) {
          decimal_number = intermediateNumber - 0.5 / 64;
        } else if (subFraction == 0) {
          decimal_number = intermediateNumber;
        } else {
          return { decimal_number: integer_part, valid: false };
        }
      } else {
        return { decimal_number: integer_part, valid: false };
      }
      break;
  }

  return { decimal_number: decimal_number, valid: true };
}

//function to validate decimal price by tickSize
export function validatePrice(price, tickSize, fractionalType) {
  if (fractionalType == "NotFractional") {
    return count(decimal(price).div(Number(tickSize))) == 0 ||
      decimal(price)
        .div(Number(tickSize))
        .toFixed(count(price))
        .toString()
        .split(".")[1] == 0
      ? true
      : false;
  } else {
    return count(decimal(price).div(Number(tickSize))) == 0 ? true : false;
  }
}

//function to count decimal places
const count = (n) => {
  const numStr = String(n);
  if (numStr.includes(".")) {
    return numStr.split(".")[1].length;
  }
  return 0;
};
